export default "__VITE_ASSET__f8762cc5__"